import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { ExtractionParameterForm } from "./ExtractionParamterForm";
import { useState } from "react";

function ExtractionParameterEdit(props) {
  const { extractionParameter, onClose, onSave } = props;

  return (
    <Dialog open={true} onClose={() => {}}>
      <DialogTitle>Edit field</DialogTitle>
      <DialogBody>
        <ExtractionParameterForm
          extractionParameter={extractionParameter}
          onSave={onSave}
          onCancel={onClose}
        />
      </DialogBody>
    </Dialog>
  );
}

export default ExtractionParameterEdit;
